module.exports = __webpack_public_path__ + "img/m-bg2.be75fcb5.png";